(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
  const details = menu.querySelector(':scope > details');

  if (!details || menu.dataset.hoverInitialized) return;

  let closeTimer;

  menu.addEventListener('mouseenter', () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    clearTimeout(closeTimer);

    document
      .querySelectorAll('.header__inline-menu header-menu > details[open]')
      .forEach((openDetails) => {
        if (openDetails !== details) {
          openDetails.removeAttribute('open');
        }
      });

    details.setAttribute('open', '');
  });

  menu.addEventListener('mouseleave', () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    closeTimer = setTimeout(() => {
      details.removeAttribute('open');
    }, 120);
  });

  menu.dataset.hoverInitialized = 'true';
});

  const connectNowContactBar = document.querySelector('.connectnow-header-contact');

  if (connectNowContactBar && !connectNowContactBar.dataset.copyInitialized) {
    let connectNowToastTimer;
    const connectNowToast = connectNowContactBar.querySelector('.connectnow-copy-toast');

    const copyConnectNowText = async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const fallbackInput = document.createElement('textarea');
      fallbackInput.value = text;
      fallbackInput.setAttribute('readonly', '');
      fallbackInput.style.position = 'fixed';
      fallbackInput.style.opacity = '0';
      document.body.appendChild(fallbackInput);
      fallbackInput.select();
      document.execCommand('copy');
      fallbackInput.remove();
    };

    connectNowContactBar.addEventListener('click', async (event) => {
      const copyButton = event.target.closest('.connectnow-copy-btn');

      if (!copyButton || !connectNowContactBar.contains(copyButton)) return;

      try {
        await copyConnectNowText(copyButton.dataset.copy || '');

        if (connectNowToast) {
          window.clearTimeout(connectNowToastTimer);
          connectNowToast.classList.add('is-visible');
          connectNowToastTimer = window.setTimeout(() => {
            connectNowToast.classList.remove('is-visible');
          }, 1400);
        }
      } catch (error) {
        console.warn('Unable to copy ConnectNow contact information.', error);
      }
    });

    connectNowContactBar.dataset.copyInitialized = 'true';
  }

  const connectNowSearchModal = document.querySelector('#ConnectNowSearchModal');
  const connectNowSearchTriggers = document.querySelectorAll('.connectnow-search-trigger');

  if (connectNowSearchModal && !connectNowSearchModal.dataset.initialized) {
    const connectNowSearchInput = connectNowSearchModal.querySelector('.connectnow-search-input');
    const connectNowSearchForm = connectNowSearchModal.querySelector('.connectnow-search-form');
    const connectNowSearchResults = connectNowSearchModal.querySelector('.connectnow-search-results');
    const connectNowSearchResultsTitle = connectNowSearchModal.querySelector('.connectnow-search-results__title');
    const connectNowSearchResultsGrid = connectNowSearchModal.querySelector('.connectnow-search-results__grid');
    const connectNowSearchAll = connectNowSearchModal.querySelector('.connectnow-search-results__all');
    const connectNowCloseButtons = connectNowSearchModal.querySelectorAll('.connectnow-search-modal__close, .connectnow-search-modal__backdrop');
    const connectNowSearchTags = connectNowSearchModal.querySelectorAll('.connectnow-search-tag');
    const connectNowPredictiveUrl = connectNowSearchModal.dataset.predictiveUrl;
    const connectNowSearchUrl = connectNowSearchModal.dataset.searchUrl;
    let connectNowSearchTimer;
    let connectNowSearchRequest;
    let connectNowSearchOpener;

    const connectNowCreateResult = (item, type) => {
      const link = document.createElement('a');
      link.className = 'connectnow-search-result';
      link.href = item.url;

      const imageUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : item.image && item.image.url
          ? item.image.url
          : '';

      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'connectnow-search-result__image';
        image.src = imageUrl;
        image.alt = item.featured_image && item.featured_image.alt ? item.featured_image.alt : '';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'connectnow-search-result__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.textContent = (item.title || '?').charAt(0).toUpperCase();
        link.appendChild(placeholder);
      }

      const content = document.createElement('span');
      content.className = 'connectnow-search-result__content';

      const resourceType = document.createElement('span');
      resourceType.className = 'connectnow-search-result__type';
      resourceType.textContent = type;

      const name = document.createElement('span');
      name.className = 'connectnow-search-result__name';
      name.textContent = item.title || 'Untitled';

      content.append(resourceType, name);
      link.appendChild(content);
      return link;
    };

    const connectNowSearchGroups = [
        ['products', 'product'],
        ['collections', 'collection'],
        ['pages', 'page'],
        ['articles', 'article']
    ];

    const connectNowNormalizeSearchText = (value) => String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const connectNowCountResources = (resources) => connectNowSearchGroups.reduce(
      (total, [key]) => total + (resources[key] || []).length,
      0
    );

    const connectNowFetchResources = async (query, signal) => {
      const params = new URLSearchParams({ q: query });
      params.set('resources[type]', 'product,page,article,collection');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'hide');

      const response = await fetch(`${connectNowPredictiveUrl}?${params.toString()}`, {
        signal,
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

      const payload = await response.json();
      return payload.resources && payload.resources.results ? payload.resources.results : {};
    };

    const connectNowFindWordMatches = async (query, signal) => {
      const words = [...new Set(connectNowNormalizeSearchText(query).split(' ').filter((word) => word.length > 1))];
      if (words.length < 2) return {};

      const responses = await Promise.all(words.slice(0, 5).map((word) => connectNowFetchResources(word, signal)));
      const matchedResources = {};

      connectNowSearchGroups.forEach(([key]) => {
        const seen = new Set();
        matchedResources[key] = [];

        responses.forEach((resources) => {
          (resources[key] || []).forEach((item) => {
            const normalizedTitle = connectNowNormalizeSearchText(item.title);
            const identity = item.url || `${key}:${normalizedTitle}`;

            if (!seen.has(identity) && words.every((word) => normalizedTitle.includes(word))) {
              seen.add(identity);
              matchedResources[key].push(item);
            }
          });
        });
      });

      return matchedResources;
    };

    const connectNowRenderResults = (resources, query) => {
      connectNowSearchResultsGrid.replaceChildren();
      let resultCount = 0;

      connectNowSearchGroups.forEach(([key, type]) => {
        (resources[key] || []).forEach((item) => {
          if (resultCount >= 8) return;
          connectNowSearchResultsGrid.appendChild(connectNowCreateResult(item, type));
          resultCount += 1;
        });
      });

      if (!resultCount) {
        const emptyMessage = document.createElement('p');
        emptyMessage.className = 'connectnow-search-results__empty';
        emptyMessage.textContent = `No results found for “${query}”.`;
        connectNowSearchResultsGrid.appendChild(emptyMessage);
      }

      connectNowSearchResultsTitle.textContent = resultCount ? 'Suggested results' : 'No matches yet';
      connectNowSearchAll.href = `${connectNowSearchUrl}?q=${encodeURIComponent(query)}&type=product%2Cpage%2Carticle`;
      connectNowSearchAll.textContent = `View all results for “${query}”`;
      connectNowSearchResults.hidden = false;
    };

    const connectNowRunSearch = async (query) => {
      const cleanQuery = query.trim();

      if (!cleanQuery) {
        connectNowSearchResults.hidden = true;
        connectNowSearchResultsGrid.replaceChildren();
        return;
      }

      if (connectNowSearchRequest) connectNowSearchRequest.abort();
      connectNowSearchRequest = new AbortController();
      connectNowSearchResults.hidden = false;
      connectNowSearchResultsTitle.textContent = 'Searching…';
      connectNowSearchResultsGrid.replaceChildren();
      connectNowSearchAll.textContent = '';

      try {
        let resources = await connectNowFetchResources(cleanQuery, connectNowSearchRequest.signal);

        if (!connectNowCountResources(resources)) {
          resources = await connectNowFindWordMatches(cleanQuery, connectNowSearchRequest.signal);
        }

        connectNowRenderResults(resources, cleanQuery);
      } catch (error) {
        if (error.name === 'AbortError') return;

        connectNowSearchResultsTitle.textContent = 'Search results';
        connectNowSearchResultsGrid.replaceChildren();
        const fallbackMessage = document.createElement('p');
        fallbackMessage.className = 'connectnow-search-results__empty';
        fallbackMessage.textContent = 'Unable to load suggestions. Use the button below to search.';
        connectNowSearchResultsGrid.appendChild(fallbackMessage);
        connectNowSearchAll.href = `${connectNowSearchUrl}?q=${encodeURIComponent(cleanQuery)}&type=product%2Cpage%2Carticle`;
        connectNowSearchAll.textContent = `Search for “${cleanQuery}”`;
      }
    };

    const connectNowOpenSearch = (opener) => {
      connectNowSearchOpener = opener;
      connectNowSearchModal.hidden = false;
      document.body.classList.add('connectnow-search-open');
      window.requestAnimationFrame(() => connectNowSearchInput.focus());
    };

    const connectNowCloseSearch = () => {
      connectNowSearchModal.hidden = true;
      document.body.classList.remove('connectnow-search-open');
      window.clearTimeout(connectNowSearchTimer);
      if (connectNowSearchRequest) connectNowSearchRequest.abort();
      if (connectNowSearchOpener) connectNowSearchOpener.focus();
    };

    connectNowSearchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => connectNowOpenSearch(trigger));
    });

    connectNowCloseButtons.forEach((button) => {
      button.addEventListener('click', connectNowCloseSearch);
    });

    connectNowSearchTags.forEach((tag) => {
      tag.addEventListener('click', () => {
        connectNowSearchInput.value = tag.dataset.query || tag.textContent.trim();
        connectNowRunSearch(connectNowSearchInput.value);
      });
    });

    connectNowSearchInput.addEventListener('input', () => {
      window.clearTimeout(connectNowSearchTimer);
      connectNowSearchTimer = window.setTimeout(() => {
        connectNowRunSearch(connectNowSearchInput.value);
      }, 250);
    });

    connectNowSearchForm.addEventListener('submit', (event) => {
      if (!connectNowSearchInput.value.trim()) {
        event.preventDefault();
        connectNowSearchInput.focus();
      }
    });

    connectNowSearchModal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        connectNowCloseSearch();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(connectNowSearchModal.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'))
        .filter((element) => element.offsetParent !== null);
      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });

    connectNowSearchModal.dataset.initialized = 'true';
  }

  } catch(e) { console.error(e); }
})();
})();
